module.exports = __webpack_public_path__ + "7b9893898cf0570db5c547ea3cd56d7f.svg";